import { apiFetch } from "./client";
import type { Bay, BaySchedule } from "./types";

export interface BayPayload {
  site_id: number;
  name: string;
  slot_duration_minutes?: number;
  is_active?: boolean;
  loads_from_rear?: boolean;
  loads_from_left?: boolean;
  loads_from_right?: boolean;
  max_vehicle_length_mm?: number | null;
}

/** The bays endpoint returns a plain array (no page envelope). */
export async function listBays(site_id?: number): Promise<Bay[]> {
  const qs = site_id !== undefined ? `?site_id=${site_id}` : "";
  return apiFetch<Bay[]>(`/bays${qs}`);
}

export async function createBay(data: BayPayload): Promise<Bay> {
  return apiFetch("/bays", { method: "POST", body: JSON.stringify(data) });
}

export async function getBay(id: number): Promise<Bay> {
  return apiFetch(`/bays/${id}`);
}

export async function updateBay(id: number, data: Partial<BayPayload>): Promise<Bay> {
  return apiFetch(`/bays/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteBay(id: number): Promise<Bay> {
  return apiFetch(`/bays/${id}`, { method: "DELETE" });
}

export async function listBaySchedules(bay_id: number): Promise<BaySchedule[]> {
  return apiFetch(`/bay-schedules?bay_id=${bay_id}`);
}

export async function createBaySchedule(data: {
  bay_id: number;
  weekday: number;
  opens_at: string;
  closes_at: string;
}): Promise<BaySchedule> {
  return apiFetch("/bay-schedules", { method: "POST", body: JSON.stringify(data) });
}

export async function deleteBaySchedule(id: number): Promise<unknown> {
  return apiFetch(`/bay-schedules/${id}`, { method: "DELETE" });
}
